export const DATE_PICKER_DROPDOWN_MIN_HEIGHT = 356
